module.exports = __webpack_public_path__ + "static/media/mapa.8c673034.svg";